// Utility for loading focus pattern images at runtime
import focusPattern0 from "../assets/patterns/focus-0.jpg";
import focusPattern1 from "../assets/patterns/focus-1.jpg";
import focusPattern2 from "../assets/patterns/focus-2.jpg";
import focusPattern3 from "../assets/patterns/focus-3.jpg";
import focusPattern4 from "../assets/patterns/focus-4.jpg";
import focusPattern5 from "../assets/patterns/focus-5.jpg";
import focusPattern6 from "../assets/patterns/focus-6.jpg";
import focusPattern7 from "../assets/patterns/focus-7.jpg";

export const focusPatternImages = [
  focusPattern0,
  focusPattern1,
  focusPattern2,
  focusPattern3,
  focusPattern4,
  focusPattern5,
  focusPattern6,
  focusPattern7,
];

export function getFocusPatternImage(idx: number): string {
  return focusPatternImages[idx % focusPatternImages.length];
}

export function focusBackgroundAtIndex(idx: number): string {
  return getFocusPatternImage(idx);
}
